const linkTextToSlug = (linkText) => linkText && linkText
  .replace(/[^a-zA-Z\d\w]/g, ' ')
  .trim()
  .replace(' ', '_')
  .toLowerCase()

export default linkTextToSlug